import IdentificationError from './IdentificationError';
class InvestorNotFound extends IdentificationError {
    constructor(options) {
        super('Investor was not found', options);
    }
}
export default InvestorNotFound;
